var React = require('react');

function TopLock (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n        .st0 {\r\n            fill: #FFFFFF;\r\n        }\r\n\r\n        .st1 {\r\n            fill: #1F2C3F;\r\n        }\r\n    "),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M21,25.3V11c0-5.3-4.3-9.6-9.6-9.6c-5.3,0-9.6,4.3-9.6,9.6v6.4c0,0.4,0.3,0.7,0.7,0.7h3.4\r\nc0.4,0,0.7-0.3,0.7-0.7V11c0-2.6,2.2-4.7,4.8-4.7c2.6,0,4.7,2.1,4.7,4.7v14.3h1.5V11c0-3.4-2.8-6.2-6.2-6.2c0,0,0,0,0,0l0,0\r\nc-3.4,0-6.2,2.8-6.2,6.2v5.6H3.2V11c0-4.5,3.7-8.1,8.2-8c4.4,0,8,3.6,8,8v14.3H21z"})))]);
}

TopLock.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"45.65px","height":"44.13px","viewBox":"0 0 40.2 43","xmlSpace":"preserve"};

module.exports = TopLock;

TopLock.default = TopLock;
